<template>
  <FormContainer
    :title="$t('title.profile')"
    :onSubmit="onSubmit"
    :isModal="false"
    :cancelRoute="'home'"
  >
    <FormItem>
      <b-input v-model="user.firstname" v-validate="'required'" name="firstName" />
    </FormItem>
    <FormItem>
      <b-input v-model="user.lastname" v-validate="'required'" name="lastName" />
    </FormItem>

    <FormItem>
      <div class="field field-body">
        <b-input v-model="user.email" name="email" disabled style="width:100%" />
        <a class="button is-primary is-light" v-show="!refreshPasswordOn" @click="changePasswordOn"
          >Şifremi Değiştir</a
        >
      </div>
    </FormItem>

    <div class="notification" v-show="refreshPasswordOn">
      <a class="delete" @click="changePasswordOff"></a>
      <FormItem>
        <b-input
          type="password"
          password-reveal
          v-model="user.password"
          name="newPassword"
          ref="password"
        />
      </FormItem>
      <FormItem>
        <b-input
          type="password"
          password-reveal
          name="confirmPassword"
          v-model="confirmPassword"
          v-validate="
            user.password && user.password.length
              ? 'required|confirmed:password'
              : 'confirmed:password'
          "
          ref="confirmPassword"
        />
      </FormItem>
    </div>

    <FormItem>
      <b-select expanded v-model="user.cityId" name="city" v-validate="'required'">
        <option v-for="option in cities" :value="option.id" :key="option.id">
          {{ option.name }}
        </option>
      </b-select>
    </FormItem>
    <FormItem>
      <b-select expanded v-model="user.jobId" name="jobInCompany" v-validate="'required'">
        <option v-for="option in jobs" :value="option.id" :key="option.id">
          {{ option.name }}
        </option>
      </b-select>
    </FormItem>
    <FormItem>
      <b-select
        expanded
        v-model="selectedSectorGroupId"
        name="companySectorGroup"
        v-validate="'required'"
        @input="onChangeSectorGroup"
      >
        <option v-for="option in sectorGroups" :value="option.id" :key="option.id">
          {{ option.name }}
        </option>
      </b-select>
    </FormItem>
    <FormItem>
      <b-select expanded v-model="user.sectorId" name="companySector" v-validate="'required'">
        <option v-for="option in sectors" :value="option.id" :key="option.id">
          {{ option.name }}
        </option>
      </b-select>
    </FormItem>
    <div slot="footer">
      <div class="field is-grouped">
        <div class="control">
          <button class="button is-primary">{{ $t('button.save') }}</button>
        </div>
        <div class="is-pulled-right">
          <div class="button is-danger" @click="cancelMembership">
            {{ $t('button.cancelMembership') }}
          </div>
        </div>
      </div>
    </div>
  </FormContainer>
</template>

<script>
import { UPDATE_USER, LOGOUT } from '../../store/actions.type'
import ApiService from '../../_api/api.service'
import ToastService from '@/_helpers/toast.service'

export default {
  data() {
    return {
      user: {},
      jobs: [],
      cities: [],
      sectorData: [],
      sectorGroups: [],
      sectors: [],
      selectedSectorGroupId: null,
      confirmPassword: null,
      refreshPasswordOn: false
    }
  },
  mounted() {
    this.user = { ...this.$store.getters.currentUser }

    ApiService.query('/select/jobs').then(data => {
      this.jobs = data
    })
    ApiService.query('/select/cities').then(data => {
      this.cities = data
    })
    ApiService.query('/select/sectors').then(data => {
      this.sectorData = data
      this.sectorGroups = data.filter(i => i.parentId == null)
      const userSector = this.sectorData.filter(s => s.id === this.user.sectorId)[0]
      this.selectedSectorGroupId = userSector.parentId
      this.onChangeSectorGroup(this.selectedSectorGroupId)
    })
  },
  methods: {
    onChangeSectorGroup(selectedid) {
      this.sectors = this.sectorData.filter(s => s.parentId === selectedid)
    },
    onSubmit() {
      this.$store
        .dispatch(UPDATE_USER, { user: this.user })
        .then(() => this.$router.push({ name: 'profile' }))
    },
    changePasswordOn() {
      this.refreshPasswordOn = true
    },
    changePasswordOff() {
      this.refreshPasswordOn = false
      this.user.password = null
      this.confirmPassword = null
    },
    cancelMembership() {
      this.$buefy.dialog.confirm({
        title: this.$t('title.cancelMembership'),
        message: this.$t('description.cancelMembershipMessage'),
        confirmText: this.$t('button.cancelMembership'),
        cancelText: this.$t('button.cancel'),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          ApiService.post('/user/cancel').then(canceled => {
            if (canceled) {
              this.$store.dispatch(LOGOUT).then(() => {
                ToastService.open({
                  type: 'is-warning',
                  message: this.$t('description.membershipCanceled')
                })
                this.$router.push({ name: 'home' })
              })
            }
          })
        }
      })
    }
  }
}
</script>
